<template>
  <div v-if="landingPageHotDeals && landingPageHotDeals.products && landingPageHotDeals.products.length">
    <v-container tag="section">
      <h2 class="text-h5 secondary--text font-weight-bold mb-7">{{ $t('label.hotDeals') }}</h2>
      <v-row>
        <v-col v-for="dealItem in landingPageHotDeals.products" :key="dealItem.id" :xs="6" :sm="3" :md="3" :lg="2" :xl="2" :cols="6">
          <Item :productInfo="dealItem" />
        </v-col>
      </v-row>
      <Spacer />
      <v-row class="text-center" justify="center">
        <v-col md="3"><app-button :label="$t('button.shopMore')" gradient invert class="text-subtitle-1 px-10 py-5" :to="{ name: $constants.ROUTE_NAME.PRODUCT_HOT_DEALS }" /></v-col>
      </v-row>
    </v-container>
    <Spacer />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Spacer from '@/components/Spacer.vue'
import Item from '@/components/product/Item.vue'

export default {
  components: { Spacer, Item },
  computed: {
    ...mapGetters('page', ['landingPageHotDeals'])
  }
}
</script>
